import {Component} from '@angular/core';
import {CreateUserComponent} from '../create-user/create-user.component';


@Component({
  selector: 'app-update-my-account',
  templateUrl: '../create-user/create-user.component.html',
  styleUrls: ['../create-user/create-user.component.scss']
})
export class UpdateMyAccountComponent extends CreateUserComponent {

  onSubmit() {
    const form = this.userEditForm;
    this.formSubmitted = true;
    this.user = {
      name: form.value.name,
      email: form.value.email,
      mobile_number: form.value.mobile_number,
      country_code: form.value.country_code,
      organization_id: form.value.organization_id,
      updated_at: undefined
    };

    if (!this.updateUser.name) {
      this.userService.createUser(this.user, null, null)
        .subscribe((result) => {
          this.updateUser = result;
          this.activeModal.dismiss('Closed on successful submit');
        });
    } else {
      this.userService.updateUser(this.user, null, this.updateUser.id)
        .subscribe((result) => {
          this.updateUser.name = result.name;
          this.updateUser.mobile_number = result.mobile_number;
          this.updateUser.updated_at = result.updatedAt;
          this.updateUser.country_code = result.country_code;
          // Object.assign(this.updateUser, result);
          this.userService.currentUserSubject.next(this.updateUser);
          localStorage.setItem('current_user', JSON.stringify(this.updateUser));
          this.activeModal.dismiss('Closed on successful submit');
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modal-edit/update-my-account/update-my-account.component.ts